export enum InvoiceType {
  INVOICE_INVALID = 1, // 發票作廢
  ALLOWANCE = 2, // 發票折讓
}
export const InvoiceTypeOptions = [
  { value: InvoiceType.INVOICE_INVALID, label: "發票作廢" },
  { value: InvoiceType.ALLOWANCE, label: "發票折讓" },
];
